<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2aRLGC/tc-custom/9780813143828.jpg?1737164481568" alt="This image is the cover for the book Kentucky Hauntings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kentucky Hauntings
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“This wonderful collection of Kentucky ghost stories” is a treasure trove of history, heritage, and commentary on the oral tradition of storytelling (Elizabeth Tucker, author of <i>Haunted Halls</i>).</b><br/>  <br/> In <i>Kentucky Hauntings</i>, beloved storytellers Roberta Simpson Brown and Lonnie E. Brown present a thrilling collection of paranormal tales that will appeal to anyone looking for a friendly scare. Weaving together factual accounts of unexplained events, peculiar headlines, and local legends passed down from a time when most homes lacked electricity, <i>Kentucky Hauntings</i> combines spooky stories with commentary on historic customs.<br/>  <br/> From "telling the bees" about a death in the family, to a friendly "fool's errand" practical joke gone horribly wrong, and from terrifying haunted houses to the lifesaving "Bathtub Ghost," readers are transported to a world of age-old superstitions and paranormal experiences. Whether shared around the fire on a crisp autumn night or whispered in a huddle of close friends at a summer sleepover, these eerie stories will thrill and excite anyone who loves a good scare.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Simpson Brown, Lonnie E. Brown
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d9aad05c